import { IIconBase } from '..'

const buyAndSaleIcon = ({
  color = '#333752',
  height = 24,
  width = 25,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/convert-3d-cube'>
        <g id='convert-3d-cube'>
          <g id='Group'>
            <path
              id='Vector'
              d='M22.5 15C22.5 18.87 19.37 22 15.5 22L16.55 20.25'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_2'
              d='M2.5 9C2.5 5.13 5.63 2 9.5 2L8.45 3.75'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <g id='Group_2'>
            <g id='Group_3'>
              <path
                id='Vector_3'
                d='M14.2002 4.44995L18.1802 6.74994L22.1202 4.45996'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='Vector_4'
                d='M18.1802 10.82V6.73999'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <path
              id='Vector_5'
              d='M17.2401 2.21L14.8401 3.53996C14.3001 3.83996 13.8501 4.59995 13.8501 5.21995V7.75999C13.8501 8.37999 14.2901 9.13998 14.8401 9.43998L17.2401 10.77C17.7501 11.06 18.5901 11.06 19.1101 10.77L21.5101 9.43998C22.0501 9.13998 22.5001 8.37999 22.5001 7.75999V5.21995C22.5001 4.59995 22.0601 3.83996 21.5101 3.53996L19.1101 2.21C18.6001 1.93 17.7601 1.93 17.2401 2.21Z'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <g id='Group_4'>
            <g id='Group_5'>
              <path
                id='Vector_6'
                d='M2.8501 15.45L6.8201 17.7499L10.7701 15.46'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='Vector_7'
                d='M6.82031 21.82V17.74'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <path
              id='Vector_8'
              d='M5.89 13.21L3.49001 14.54C2.95001 14.84 2.5 15.5999 2.5 16.2199V18.76C2.5 19.38 2.94001 20.14 3.49001 20.44L5.89 21.77C6.4 22.06 7.23999 22.06 7.75999 21.77L10.16 20.44C10.7 20.14 11.15 19.38 11.15 18.76V16.2199C11.15 15.5999 10.71 14.84 10.16 14.54L7.75999 13.21C7.23999 12.93 6.4 12.93 5.89 13.21Z'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default buyAndSaleIcon
